export default theme => ({
    sliderContainer: {
        margin: theme.spacing(0, 0.5),
    },
    slider: {
        color: theme.palette.primary.main,
        '& .MuiSlider-rail': {
            opacity: 0.3,
            backgroundColor: theme.palette.primary.light,
        },
        '& .MuiSlider-track': {
            border: 'none',
            backgroundColor: theme.palette.primary.main,
        },
        '& .MuiSlider-thumb': {
            backgroundColor: theme.palette.primary.main,
        },
        // Current value bubble shown in primary.
        '& .MuiSlider-valueLabel': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
        '& .MuiSlider-markLabel': {
            color: theme.palette.text.secondary,
        },
    },
    label: {
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    error: {
        color: theme.palette.error.main,
    },
});
